import { render } from "./PlatformPage.vue?vue&type=template&id=2bd1f9db&scoped=true"
import script from "./PlatformPage.vue?vue&type=script&lang=js"
export * from "./PlatformPage.vue?vue&type=script&lang=js"

import "./PlatformPage.vue?vue&type=style&index=0&id=2bd1f9db&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd1f9db"]])

export default __exports__